// extracted by mini-css-extract-plugin
export default {"popover":"MoreActionsButton_popover__1WtVo"};